import * as Yup from "yup";

export const Validator = () => {
  return Yup.object({
    agency: Yup.string().required("Agency is required"),
    name: Yup.string().required("Name is required"),
    shiftWorked: Yup.string().required("Shift worked is required"),
    unitAssignment: Yup.string().required("Unit assignment is required"),
    SSN: Yup.string().required("SSN is required"),
  });
};
